import { Message } from "element-ui";

/**
 * 防抖
 * @param fn 传入方法
 * @param delay 传入时间
 * @使用闭包防止重复创建影响性能
 */
export function debounce(func, wait = 500) {
  let timeout;
  return function(event) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.call(this, event);
    }, wait);
  };
}

export function InterfaceMessage(res) {
  if (res.code !== 200)
    return Message({
      message: res.message || "Error",
      type: "error",
    });
  return res.data;
}

// import from "@/utils/tool.js";
